import { render, staticRenderFns } from "./PerformaceReports.vue?vue&type=template&id=2e2bb764&scoped=true"
import script from "./PerformaceReports.vue?vue&type=script&lang=js"
export * from "./PerformaceReports.vue?vue&type=script&lang=js"
import style0 from "./PerformaceReports.vue?vue&type=style&index=0&id=2e2bb764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2bb764",
  null
  
)

export default component.exports